import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const wrapper = (theme: Theme) => css`
  background-color: ${theme.system.backgroundBase};
  border-bottom: 1px solid ${theme.system.borderBase};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem 1rem;
  margin: 0 -1rem 1rem;
  position: sticky;
  top: 0;

  @media (min-width: ${dimensions.desktop}) {
    background: transparent;
    border-bottom: 0;
    margin-bottom: 0;
    position: static;
    top: auto;
  }
`;
